import { NOTARY_BAD_REQUEST_API_I18N } from "@Front/Components/DesignSystem/helpers/commonUiI18nNotaryBadRequestCatalog";

export const ANTIVIRUS_UNAVAILABLE_USER_MESSAGE =
	NOTARY_BAD_REQUEST_API_I18N.NOTARY_BAD_REQUEST_FILE_UPLOAD_ANTIVIRUS_UNAVAILABLE;

export function isAntivirusConnectionUserError(text: string): boolean {
	return /ECONNRESET|EPIPE|ECONNREFUSED|ClamAV scan connection was reset|antivirus est indisponible/i.test(
		text,
	);
}
